import type { Catalog } from "../../en";

export const availability: Catalog["build"]["actions"]["availability"] = {
  title: "Availability",
  subtitle: "Kailan puwedeng mag-book ang mga bisita at paano kinukumpirma ang mga booking.",
  banner: {
    calendar: {
      title: "Sa Google Calendar ginagawa ang mga booking",
      body: "Galing sa {{calendar}} ang mga bakanteng oras. Nagiging event sa calendar ang bawat booking.",
      bodyNoName: "Galing sa nakakonektang calendar ang mga bakanteng oras. Nagiging event sa calendar ang bawat booking.",
    },
    request: {
      title: "Nagpapadala ng booking request ang mga bisita",
      body: "Tinatanggap o tinatanggihan ng team mo ang bawat isa sa Leads → Bookings.",
      connectHint: "I-connect ang Google Calendar para awtomatikong makumpirma ang mga oras.",
      connect: "I-connect ang Google Calendar",
      open: "Buksan ang mga booking",
    },
    unconfigured: {
      title: "Wala pang inaalok na oras sa mga bisita",
      body: "Itakda ang oras ng bukas sa ibaba at i-save. Hangga't hindi pa, walang maiaalok na oras ng appointment ang assistant.",
      cta: "Itakda ang oras ng bukas",
    },
  },
  mode: {
    label: "Paano kinukumpirma ang mga booking",
    auto: "Awtomatiko",
    autoHint: "Gumagamit ng Google Calendar kapag nakakonekta. Kung walang calendar, magpapadala ng request ang bisita at kukumpirmahin ito ng team mo.",
    request: "Laging hingin ang kumpirmasyon ng staff",
    requestHint: "Humihiling ng oras ang bisita at tinatanggap o tinatanggihan ito ng team mo sa Leads → Bookings, kahit may nakakonektang calendar.",
  },
  timezone: {
    label: "Time zone",
    workspace: "Time zone ng workspace ({{zone}})",
    hint: "Sinusunod ng oras ng bukas sa ibaba ang time zone na ito.",
  },
  hours: {
    title: "Lingguhang oras",
    hint: "Magdagdag ng hanggang {{count}} saklaw ng oras bawat araw. Iwanang sarado ang araw kung walang tumatanggap ng booking.",
    closed: "Sarado",
    openToggle: "Bukas ng {{day}}",
    opens: "{{day}}, saklaw {{number}}: nagbubukas ng",
    closes: "{{day}}, saklaw {{number}}: nagsasara ng",
    add: "Magdagdag ng saklaw ng oras",
    addLabel: "Magdagdag ng saklaw ng oras sa {{day}}",
    remove: "Alisin ang saklaw {{number}} sa {{day}}",
    copy: "Kopyahin sa Lun–Biy",
    copyLabel: "Kopyahin ang oras ng {{day}} sa Lunes hanggang Biyernes",
    copied: "Nakopya ang oras ng {{day}} sa Lunes–Biyernes",
    days: {
      mon: "Lunes",
      tue: "Martes",
      wed: "Miyerkules",
      thu: "Huwebes",
      fri: "Biyernes",
      sat: "Sabado",
      sun: "Linggo",
    },
  },
  timing: {
    slotMinutes: "Haba ng appointment (minuto)",
    slotMinutesHint: "10 hanggang 240",
    bufferMinutes: "Pagitan ng mga booking (minuto)",
    bufferMinutesHint: "0 hanggang 120",
    minNoticeHours: "Pinakamaikling abiso (oras)",
    minNoticeHoursHint: "0 hanggang 720. Hindi makakapag-book ang bisita nang mas maaga rito.",
    horizonDays: "Puwedeng i-book hanggang (araw mula ngayon)",
    horizonDaysHint: "1 hanggang 180",
  },
  blocked: {
    title: "Mga naka-block na petsa",
    hint: "Mga holiday at iba pang araw na sarado ka (hanggang {{count}}).",
    dateLabel: "Petsang iba-block",
    add: "I-block ang petsa",
    remove: "Alisin ang block sa {{date}}",
    list: "Mga naka-block na petsa",
    none: "Walang naka-block na petsa.",
    duplicate: "Naka-block na ang petsang iyon.",
    full: "Hanggang {{count}} petsa lang ang puwedeng i-block.",
    invalid: "Pumili ng wastong petsa.",
  },
  location: {
    label: "Lokasyon",
    hint: "Kung saan gaganapin ang booking. Makikita ng bisita at nasa event sa calendar.",
    placeholder: "Admissions Office, 2nd floor",
  },
  meet: {
    label: "Magdagdag ng Google Meet link",
    hint: "Magkakaroon ng video link ang mga booking sa calendar, bagay sa online na konsultasyon.",
  },
  save: "I-save ang availability",
  saved: "Na-save ang availability",
  readOnly: "Makikita mo ang mga patakarang ito, pero kailangan ng pahintulot na mag-manage ng mga aksyon para baguhin ang mga ito.",
  errors: {
    clock: "Maglagay ng oras tulad ng 09:00.",
    rangeOrder: "Dapat matapos pagkatapos magsimula ang bawat saklaw ng oras.",
    overlap: "Hindi dapat magpatong ang mga saklaw ng oras sa iisang araw.",
    maxRanges: "Hanggang {{count}} saklaw ng oras lang bawat araw.",
    noOpenDay: "Magbukas ng kahit isang araw sa linggo.",
    slotMinutes: "Maglagay ng buong bilang mula 10 hanggang 240 minuto.",
    bufferMinutes: "Maglagay ng buong bilang mula 0 hanggang 120 minuto.",
    minNoticeHours: "Maglagay ng buong bilang mula 0 hanggang 720 oras.",
    horizonDays: "Maglagay ng buong bilang mula 1 hanggang 180 araw.",
    blockedMax: "Hanggang {{count}} petsa lang ang puwedeng i-block.",
    locationMax: "Panatilihing wala pang {{count}} character ang lokasyon.",
    timezone: "Pumili ng wastong time zone, halimbawa Asia/Manila.",
  },
};
